/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { basic_response } from '../models/basic_response';
import type { GetTeam } from '../models/GetTeam';
import type { PostTeam } from '../models/PostTeam';
import type { PutTeam } from '../models/PutTeam';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TeamAndDepartmentService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Creates a new Team or Department
     * @param requestBody 
     * @returns basic_response Created
     * @throws ApiError
     */
    public create(
requestBody: PostTeam,
): CancelablePromise<basic_response> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/teams/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Internal system error`,
            },
        });
    }

    /**
     * Searches existing Teams or Departments
     * @param searchKeyword 
     * @param status 
     * @returns GetTeam Success
     * @throws ApiError
     */
    public search(
searchKeyword?: string,
status?: 'Active' | 'Inactive',
): CancelablePromise<GetTeam> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/teams/search',
            query: {
                'search_keyword': searchKeyword,
                'status': status,
            },
            errors: {
                400: `Bad Role Request`,
                500: `Internal system error`,
            },
        });
    }

    /**
     * Retrieves a Team or Department
     * @param teamId 
     * @returns GetTeam Success
     * @throws ApiError
     */
    public get(
teamId: number,
): CancelablePromise<GetTeam> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/teams/{team_id}',
            path: {
                'team_id': teamId,
            },
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Team does not exists`,
                500: `Internal system error`,
            },
        });
    }

    /**
     * Updates a Team or Department
     * @param teamId 
     * @param requestBody 
     * @returns GetTeam Success
     * @throws ApiError
     */
    public update(
teamId: number,
requestBody: PutTeam,
): CancelablePromise<GetTeam> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/teams/{team_id}',
            path: {
                'team_id': teamId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Role Request does not exists`,
                500: `Internal system error`,
            },
        });
    }

}
